module.exports = __webpack_public_path__ + "img/app-store-icon.1824f423.png";